const toReplace = Object.entries({
  "И": "І",
  "и": "і",
  "Щ": "Ў",
  "щ": "ў",
  "Ъ": "'",
  "ъ": "'"
});

export function belarusify(text) {
  let result = text.toString();

  for (const [k, v] of toReplace) {
    result = result.replaceAll(k, v);
  }

  return result;
}